import designIcon from "../../../images/categories/design.png";
import developmentIcon from "../../../images/categories/development.png";
import marketingIcon from "../../../images/categories/marketing.png";

import { internshipLink } from "../../../common/routes";

const CategoriesData = [
  {
    url: `${internshipLink}#design`,
    imgUrl: designIcon,
    title: "Design Internship",
    paragraph:
      "Design no code websites and applications that attract users' attention and perform effectively in search engines.",
  },
  {
    url: `${internshipLink}#development`,
    imgUrl: developmentIcon,
    title: "Development Internship",
    paragraph:
      "Develop websites and applications that attract users' attention and perform effectively in search engines.",
  },
  {
    url: `${internshipLink}#marketing`,
    imgUrl: marketingIcon,
    title: "Marketing Internship",
    paragraph:
      "Learn how to use search engines and social media to efficiently market your product or service.",
  },
  {
    url: `${internshipLink}#marketing`,
    imgUrl: marketingIcon,
    title: "Test Content",
    paragraph:
      "Learn how to use search engines and social media to efficiently market your product or service.",
  },
];

export default CategoriesData;
